




import Vue from 'vue';

import * as ping from '@/lib/usage_ping';

export default Vue.extend({
    props: ['extraClasses'],
    methods: {
        goToCheckout() {
            ping.send({ type: ping.UserUsage.clicktrial, uid: this.currentUser.uid });
            this.$router.push(this.$store.state.checkoutDefaultURL)
        }
    }
})
